

/** @type {import('./pow')} */
module.exports = Math.pow;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/pow.js
// module id = ../node_modules/math-intrinsics/pow.js
// module chunks = 0